const apiBaseURL = 'https://api.mamanestdebout.org/';

export default apiBaseURL;
